export default __webpack_public_path__ + "static/media/Illustration_Money.6fe42e84.svg";